var map = {
	"./activity-calculate.svg": 465,
	"./activity-consider.svg": 466,
	"./activity-discuss.svg": 467,
	"./activity-evaluate.svg": 468,
	"./activity-explore.svg": 469,
	"./activity-rolePlay.svg": 470,
	"./activity-write.svg": 471,
	"./ahoy-duration.svg": 472,
	"./ahoy-huh.svg": 473,
	"./ahoy-like.svg": 474,
	"./ahoy-sad.svg": 475,
	"./ahoy-uniques.svg": 476,
	"./ahoy-views.svg": 477,
	"./ahoy-wow.svg": 478,
	"./back.svg": 479,
	"./comments-close.svg": 480,
	"./consider.svg": 481,
	"./dashboard-delete.svg": 482,
	"./dashboard-done.svg": 483,
	"./dashboard-edit.svg": 484,
	"./edgenote-aside.svg": 437,
	"./edgenote-audio.svg": 438,
	"./edgenote-graphic.svg": 439,
	"./edgenote-link.svg": 440,
	"./edgenote-photo.svg": 441,
	"./edgenote-quote.svg": 442,
	"./edgenote-report.svg": 443,
	"./edgenote-video.svg": 444,
	"./explore.svg": 485,
	"./file-audio.svg": 486,
	"./file-basic.svg": 487,
	"./file-code.svg": 488,
	"./file-data.svg": 489,
	"./file-image.svg": 490,
	"./file-model.svg": 491,
	"./file-shapes.svg": 492,
	"./file-spreadsheet.svg": 493,
	"./file-tasks.svg": 494,
	"./file-text.svg": 495,
	"./file-video.svg": 496,
	"./link.svg": 445,
	"./listen.svg": 497,
	"./loading.svg": 498,
	"./modal-close.svg": 499,
	"./pin.svg": 435,
	"./read.svg": 500,
	"./repond.svg": 501,
	"./respond.svg": 502,
	"./toc-podcast.svg": 503,
	"./toc-roleplay.svg": 504,
	"./trash.svg": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;